import { createKeyFactory } from '@clouway/query'

export const accountKeys = createKeyFactory('account')

export const settingsKey = () => accountKeys.custom('settings')
